export default __webpack_public_path__ + "static/media/award-5.8550904b.png";